export class EventBus<EventMap extends Record<string, (...args: any[]) => void>> {
  private listeners: { [K in keyof EventMap]?: Set<EventMap[K]> } = {};

  addEventListener<Event extends keyof EventMap>(event: Event, listener: EventMap[Event]): () => void {
    if (!this.listeners[event]) {
      this.listeners[event] = new Set();
    }
    this.listeners[event].add(listener);
    return this.removeEventListener.bind(this, event, listener);
  }

  removeEventListener<Event extends keyof EventMap>(event: Event, listener: EventMap[Event]): void {
    if (!this.listeners[event]) {
      return;
    }
    this.listeners[event].delete(listener);
  }

  protected dispatchEvent<Event extends keyof EventMap>(event: Event, ...args: Parameters<EventMap[Event]>): void {
    if (!this.listeners[event]) {
      return;
    }
    this.listeners[event].forEach((listener) => listener(...args));
  }
}
